import { SpotLight, DirectionalLight, Group } from "three";

export default class Lights {

    constructor(GAME) {
        this.GAME = GAME;

        this.init();
    }

    init() {
        this.addSparklight();
        this.addSpotlight();
        this.addSunlight();
        this.addFloorLight();
        this.addDirectionalLights();
        this.addPaddingSideLights();
    }

    createShadowConfig = (light, mapSize = 1024) => {
        light.castShadow = true;
        light.shadow.camera.near = 0.1;
        light.shadow.camera.far = 100;
        light.shadow.camera.right = 50;
        light.shadow.camera.left = -50;
        light.shadow.camera.top = 50;
        light.shadow.camera.bottom = -50;
        light.shadow.mapSize.set(mapSize, mapSize);
    }

    addSparklight() {
        // this.sparkLight = new SpotLight(0xff0000, 202);
        // this.sparkLight.position.set(-5, 25, 28);
        // this.sparkLight.target = this.GAME.spark;
        // this.GAME.scene.add(this.sparkLight);
        // this.GAME.scene.add(this.sparkLight.target);
    }

    addSpotlight() {
        this.spotLight = new SpotLight(0xffffff, 22);
        this.spotLight.position.set(3, 25, 18);
        this.spotLight.target = this.GAME.logo;
        this.GAME.TIME.addEventListener('tick', () => this.spotLight.position.x = Math.sin(this.GAME.TIME.elapsed / 600) * 5)
        this.GAME.scene.add(this.spotLight);
        this.GAME.scene.add(this.spotLight.target);
    }

    addSunlight() {
        this.sunLight = new DirectionalLight(0xffffff, 3);
        this.sunLight.position.set(0, 80, 0);
        if (this.GAME.config.shadows) this.createShadowConfig(this.sunLight, 512);
        this.GAME.scene.add(this.sunLight);
    }

    addFloorLight() {
        this.lightGroup = new Group();
        this.floorLight = new DirectionalLight(this.GAME.config.lights.floor.colour, this.GAME.config.lights.floor.intensity);
        this.floorLight.position.set(0, 0.01, -2); // position away from center
        this.floorLight.target.position.set(0, 111110, 0);

        this.lightGroup.add(this.floorLight);
        this.lightGroup.add(this.floorLight.target);
        this.GAME.scene.add(this.lightGroup);


        if (this.debug) {
            this.floorLightHelper = new DirectionalLightHelper(this.floorLight, 1.5);
            this.floorLightHelper.visible = true;
            this.GAME.scene.add(this.floorLightHelper);
        }

        this.GAME.scene.add(this.floorLight);
    }

    addDirectionalLights() {
        for (let l = 0; l < 5; l++) {
            const dirLight = new DirectionalLight(0xffffff, Math.PI / (l + 1));
            dirLight.name = `Dir. Light ${l}`;
            dirLight.position.set(0, 2, 2);
            if (this.GAME.config.shadows) this.createShadowConfig(dirLight);
            dirLight.intensity = 0.4;
            if (this.GAME.config.shadows) dirLight.shadow.radius = 0.2;
            if (this.GAME.config.shadows) dirLight.shadow.blurSamples = 22;
            this.GAME.scene.add(dirLight);
        }
    }

    // Fill light for the goal padding's ±X side faces, which the
    // sun/floor/front-facing lights above don't reach.
    addPaddingSideLights() {
        const { position } = this.GAME.config.paddingLeft;

        this.sideLightRight = new DirectionalLight(0xffffff, 2.5);
        this.sideLightRight.position.set(15, position.y + 3, position.z);
        this.sideLightRight.target.position.set(0, position.y, position.z);
        this.GAME.scene.add(this.sideLightRight);
        this.GAME.scene.add(this.sideLightRight.target);

        this.sideLightLeft = new DirectionalLight(0xffffff, 2.5);
        this.sideLightLeft.position.set(-15, position.y + 3, position.z);
        this.sideLightLeft.target.position.set(0, position.y, position.z);
        this.GAME.scene.add(this.sideLightLeft);
        this.GAME.scene.add(this.sideLightLeft.target);
    }

}